import * as React from 'react'
import { Button } from 'react-bootstrap'
import { graphql, useStaticQuery } from 'gatsby'
import { ClassName } from '@type/component-data-types'

type Props = {
  className?: ClassName
}

// markup
const ClientCta = (props: Props): React.JSX.Element => {
  // パートナー登録ページのURLを取得
  const data = useStaticQuery(graphql`
    {
      dataJson {
        clientContact
        clientDocumentDownload
      }
    }
  `)

  const clientContactPath = data.dataJson.clientContact
  const clientDocumentDownloadPath = data.dataJson.clientDocumentDownload
  const defaultClassName = `clientCta mx-auto`
  const updateClassName = props.className
    ? `${defaultClassName} ${props.className}`
    : `${defaultClassName}`

  return (
    <>
      <div className={updateClassName}>
        <p className="clientCta__message mb-1 text-center">
          afbで広告出稿してみませんか？
        </p>
        <div className="clientCta__buttons mx-auto">
          <Button
            href={clientDocumentDownloadPath}
            variant="client-document"
            className="clientCtaBtn"
            data-cta-location="contentDocumentDownload"
          >
            資料をダウンロードする
          </Button>
          <Button
            href={clientContactPath}
            variant="client"
            className="clientCtaBtn"
            data-cta-location="contentContact"
          >
            お問い合わせ
          </Button>
        </div>
      </div>
    </>
  )
}

export default ClientCta
